<template>
  <div class="ag-risco-matriz">
    <table class="ag-risco-matriz__table" border="0">
      <tbody>
        <tr>
          <td rowspan="3" class="ag-risco-matriz__table-legend ag-risco-matriz__table-legend--vertical">Prioridade</td>
          <td
            class="ag-risco-matriz__table-data ag-risco-matriz__table-data--header ag-risco-matriz__table-data--align-end"
          >
            Alta
          </td>
          <td class="ag-risco-matriz__table-data ag-risco-matriz__table-data--elevado">Elevado</td>
          <td class="ag-risco-matriz__table-data ag-risco-matriz__table-data--critico">Crítico</td>
          <td class="ag-risco-matriz__table-data ag-risco-matriz__table-data--critico">Crítico</td>
        </tr>
        <tr>
          <td
            class="ag-risco-matriz__table-data ag-risco-matriz__table-data--header ag-risco-matriz__table-data--align-end"
          >
            Média
          </td>
          <td class="ag-risco-matriz__table-data ag-risco-matriz__table-data--moderado">Moderado</td>
          <td class="ag-risco-matriz__table-data ag-risco-matriz__table-data--elevado">Elevado</td>
          <td class="ag-risco-matriz__table-data ag-risco-matriz__table-data--critico">Crítico</td>
        </tr>
        <tr>
          <td
            class="ag-risco-matriz__table-data ag-risco-matriz__table-data--header ag-risco-matriz__table-data--align-end"
          >
            Baixa
          </td>
          <td class="ag-risco-matriz__table-data ag-risco-matriz__table-data--baixo">Baixo</td>
          <td class="ag-risco-matriz__table-data ag-risco-matriz__table-data--moderado">Moderado</td>
          <td class="ag-risco-matriz__table-data ag-risco-matriz__table-data--elevado">Elevado</td>
        </tr>
        <tr class="ag-risco-matriz__table-row">
          <td></td>
          <td class="ag-risco-matriz__table-data ag-risco-matriz__table-data--header"></td>
          <td class="ag-risco-matriz__table-data ag-risco-matriz__table-data--header">Insignificante</td>
          <td class="ag-risco-matriz__table-data ag-risco-matriz__table-data--header">Médio</td>
          <td class="ag-risco-matriz__table-data ag-risco-matriz__table-data--header">Crítico</td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td colspan="3" class="ag-risco-matriz__table-legend ag-risco-matriz__table-legend--horizontal">Impacto</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.ag-risco-matriz {
  display: flex;
  .ag-risco-matriz__table {
    table-layout: fixed;
    width: 100%;
    border-spacing: 0;
    border: $border-default $border-width-hairline $brand-color-primary-light;
    border-radius: $border-radius-sm;
    font-size: $font-size-xxxs;

    tr:first-child > .ag-risco-matriz__table-data--critico:last-child {
      border-radius: 0 $border-radius-sm 0 0;
    }

    .ag-risco-matriz__table-row {
      height: 32px;
    }

    .ag-risco-matriz__table-legend {
      align-content: center;
      text-align: center;
      color: $neutral-color-high-light;
      background-color: $neutral-color-low-dark;
      border-radius: $border-radius-sm 0;

      &--vertical {
        transform: rotate(180deg);
        writing-mode: vertical-lr;
        width: 24px;
      }

      &--horizontal {
        height: 24px;
      }
    }

    .ag-risco-matriz__table-data {
      padding: $spacing-03;
      align-content: center;
      text-align: center;
      box-sizing: content-box;

      &--header {
        background-color: $neutral-color-low-light;
        color: $neutral-color-high-light;
      }

      &--align-end {
        text-align: end;
        width: 52px;
      }

      &--elevado {
        background-color: $feedback-color-more-attention-flourescent;
        color: $feedback-color-more-attention-dark;
      }

      &--critico {
        background-color: $feedback-color-error-flourescent;
        color: $neutral-color-low-light;
      }

      &--moderado {
        background-color: $feedback-color-attention-flourescent;
        color: $feedback-color-attention-dark;
      }

      &--baixo {
        background-color: $feedback-color-success-flourescent;
        color: $neutral-color-low-light;
      }
    }
  }
}
</style>
